(() => {
  const attrNames = ['Alcohol purchaser date of birth', 'Alcohol declaration accepted', 'Alcohol declaration typed name', 'Alcohol declaration accepted at', 'Alcohol declaration version'];
  let busy = false;
  let hadAlcohol = false;
  let scheduled = false;
  const root = () => window.Shopify?.routes?.root || '/';
  const panels = () => [...document.querySelectorAll('[data-pt-age-panel]')];
  const cartHasAlcohol = () => [...document.querySelectorAll('[data-pt-alcohol-state]')].some(el => el.dataset.ptAlcoholState === 'true');
  const today = () => {
    const parts = new Intl.DateTimeFormat('en-US', {timeZone:'America/New_York',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
    const get = key => Number(parts.find(p => p.type === key).value);
    return [get('year'),get('month'),get('day')];
  };
  const ageFromDob = (value, now = today()) => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
    const [year,month,day] = value.split('-').map(Number);
    const date = new Date(Date.UTC(year,month-1,day));
    if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month-1 || date.getUTCDate() !== day) return null;
    let age = now[0]-year;
    if (now[1]<month || (now[1]===month && now[2]<day)) age--;
    return age < 0 || age > 120 ? null : age;
  };
  const validate = panel => {
    const dob = panel.querySelector('[data-pt-dob]');
    const accept = panel.querySelector('[data-pt-accept]');
    const signature = panel.querySelector('[data-pt-signature]');
    const age = ageFromDob(dob.value);
    if (dob.value && age === null) return {valid:false,message:panel.dataset.msgInvalid,field:dob};
    if (age !== null && age < 21) return {valid:false,message:panel.dataset.msgUnderage,field:dob};
    if (!dob.value || !accept.checked || signature.value.trim().length < 2) return {valid:false,message:panel.dataset.msgMissing,field:!dob.value?dob:!accept.checked?accept:signature};
    return {valid:true};
  };
  const update = () => {
    scheduled = false;
    const restricted = cartHasAlcohol();
    for (const panel of panels()) {
      const result = validate(panel);
      const formId = panel.dataset.formId;
      document.querySelectorAll('[data-cart-checkout-button]').forEach(button => {
        if ((button.form?.id || button.getAttribute('form')) === formId) button.disabled = busy || !result.valid;
      });
      const dob = panel.querySelector('[data-pt-dob]');
      const [year,month,day] = today();
      dob.max = `${year}-${String(month).padStart(2,'0')}-${String(day).padStart(2,'0')}`;
    }
    document.querySelectorAll('.cart-additional-checkout-buttons,.cart-drawer-additional-checkout-buttons').forEach(el => {
      if (restricted) {el.dataset.ptAgeHidden='true';el.hidden=true;}
      else if (el.dataset.ptAgeHidden) {el.hidden=false;delete el.dataset.ptAgeHidden;}
    });
    if (restricted) document.querySelectorAll('.shopify-payment-button').forEach(el => {el.hidden=true;el.dataset.ptAgeHidden='true';});
    else document.querySelectorAll('.shopify-payment-button[data-pt-age-hidden]').forEach(el => {el.hidden=false;delete el.dataset.ptAgeHidden;});
    if (hadAlcohol && !restricted) {
      fetch(root()+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:Object.fromEntries(attrNames.map(key=>[key,'']))})}).catch(()=>{});
    }
    hadAlcohol=restricted;
  };
  const schedule = () => {
    if (!scheduled) {scheduled=true;queueMicrotask(update);}
  };
  const showError = (panel,message,field) => {
    const error=panel.querySelector('[data-pt-age-error]');
    error.textContent=message;
    error.hidden=false;
    field?.focus();
  };
  document.addEventListener('input', event => {
    const panel=event.target.closest('[data-pt-age-panel]');
    if (panel) {
      const result=validate(panel);
      const error=panel.querySelector('[data-pt-age-error]');
      if (result.field?.matches('[data-pt-dob]') && panel.querySelector('[data-pt-dob]').value) {error.textContent=result.message;error.hidden=false;}
      else {error.hidden=true;error.textContent='';}
      update();
    }
  });
  document.addEventListener('change', event => {if (event.target.closest('[data-pt-age-panel]')) update();});
  document.addEventListener('submit', async event => {
    const form=event.target;
    const panel=panels().find(el=>el.dataset.formId===form.id);
    if (!panel) return;
    const submitter=event.submitter;
    if (submitter && submitter.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;
    const result=validate(panel);
    if (!result.valid) {showError(panel,result.message,result.field);return;}
    busy=true;update();
    const attributes={
      [attrNames[0]]:panel.querySelector('[data-pt-dob]').value,
      [attrNames[1]]:'Yes',
      [attrNames[2]]:panel.querySelector('[data-pt-signature]').value.trim(),
      [attrNames[3]]:new Date().toISOString(),
      [attrNames[4]]:'2026-10-03-v1'
    };
    try {
      const response=await fetch(root()+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes})});
      if (!response.ok) throw new Error('Cart update failed');
      const cart=await response.json();
      if (!attrNames.every(key=>cart.attributes?.[key]===attributes[key])) throw new Error('Declaration not saved');
      window.location.assign(root()+'checkout');
    } catch {
      showError(panel,panel.dataset.msgSave);
      busy=false;update();
    }
  },true);
  document.addEventListener('click', event => {
    const link=event.target.closest('a[href]');
    if (link && cartHasAlcohol() && /\/checkout(?:[/?#]|$)/.test(new URL(link.href,location.href).pathname)) {
      event.preventDefault();event.stopImmediatePropagation();window.location.assign(root()+'cart');
    }
  },true);
  const start=()=>{update();new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});};
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
